import { useEffect, useRef, useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

// Lote 115 (Robson, 24/10/2026) — "enxugar o app": o que não é essencial da função fica numa linha
// recolhida, com o RESUMO do que há dentro (você vê sem abrir). Abre com 1 toque; abre sozinha quando já
// vem preenchida (da ata, da publicação, ao editar) e, depois que a pessoa abre ou fecha, respeita a escolha.
// Alertas e erros NUNCA ficam aqui dentro.
export default function Recolhivel({ titulo, resumo, preenchido = false, icon: Icon, children, testid, borda = true }) {
  const [open, setOpen] = useState(!!preenchido);
  const mexeu = useRef(false);
  useEffect(() => { if (preenchido && !mexeu.current) setOpen(true); }, [preenchido]);
  return (
    <div className={borda ? "border-t border-stone-200" : ""} data-testid={testid}>
      <button
        type="button"
        data-testid={testid ? `${testid}-toggle` : undefined}
        aria-expanded={open}
        onClick={() => { mexeu.current = true; setOpen((o) => !o); }}
        className="w-full flex items-center gap-2 min-h-[44px] py-2 text-left hover:bg-stone-50 rounded-md"
      >
        {Icon ? <Icon className="w-3.5 h-3.5 text-stone-500 shrink-0" strokeWidth={2} /> : null}
        <span className="text-sm font-semibold text-stone-700 shrink-0">{titulo}</span>
        {resumo ? <span className="text-[11px] text-stone-500 truncate min-w-0">· {resumo}</span> : null}
        <span className="ml-auto pl-2 text-stone-400 shrink-0">
          {open ? <ChevronDown className="w-4 h-4" strokeWidth={2} /> : <ChevronRight className="w-4 h-4" strokeWidth={2} />}
        </span>
      </button>
      {open && <div className="pb-3 space-y-3">{children}</div>}
    </div>
  );
}
